import { SHOW_FILTER, HIDE_FILTER, TOGGLE_FILTER } from '../actions/types';

const INIT_STATE = {
  show: false,
  anchor: 'right',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SHOW_FILTER: {
      return {
        ...state,
        show: true,
      };
    }
    case HIDE_FILTER: {
      return {
        ...state,
        show: false,
      };
    }
    case TOGGLE_FILTER: {
      return {
        ...state,
        show: !state.show,
      };
    }
    default:
      return state;
  }
};
